import { User } from "../types/api-schema";

export default async function fetchUserInfo<T = User>(
  url: string,
  init?: RequestInit,
): Promise<null | T> {
  let userInfo: null | T = null;
  try {
    const response = await fetch(url, init);
    if (response.ok) {
      userInfo = await response.json();
    } else {
      throw new Error(response.statusText);
    }
  } catch (err) {
    if (err && err.name !== "AbortError" && err.message !== "Unauthorized") {
      // Show error except for user abort request and response when user login failed because it is unauthorized (not logged in)
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }
  return userInfo;
}
